import React, { createContext, useContext, useState, useCallback } from 'react';
import fr from '../lang/fr';
import en from '../lang/en';
import de from '../lang/de';
import sv from '../lang/sv';

const TRANSLATIONS = { fr, en, de, sv };
const STORAGE_KEY  = 'arcusconnect_lang';

const LanguageContext = createContext({ lang: 'fr', t: (k) => k, setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || 'fr'
  );

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem(STORAGE_KEY, l);
  }, []);

  // t('polices.declared_ca') → string in current language
  // Falls back to French if key missing in current language
  const t = useCallback((key) => {
    const keys    = key.split('.');
    const tryLang = (dict) => {
      let v = dict;
      for (const k of keys) { v = v?.[k]; }
      return typeof v === 'string' ? v : undefined;
    };
    return tryLang(TRANSLATIONS[lang]) ?? tryLang(TRANSLATIONS.fr) ?? key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, t, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
